module.exports = __webpack_public_path__ + "img/banner.8c5fa74a.png";